// src/components/TopicCard.tsx

import { Link } from 'react-router-dom';
import { Topic, TopicLearning } from '../types';
import genericTopicImageUrl from '../assets/topic-icon.svg';

interface TopicCardProps {
  topic: TopicLearning;
}

function TopicCard({ topic }: TopicCardProps) {
  const progressPercent = Math.round(topic.progress);

  return (
    <div className="topic-card glass-effect">
      <img src={genericTopicImageUrl} alt={topic.name} className="topic-image" />
      <div className="topic-info">
        <h3>{topic.name}</h3>
        <p className="topic-meta">
          <span className="topic-word-count">{topic.vocabularyCount} words</span>
        </p>
        {/* --- KHỐI PROGRESS BAR MỚI --- */}
        <div className="topic-progress">
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${progressPercent}%` }}
            ></div>
          </div>
          <span className="progress-label">{progressPercent}%</span>
        </div>
        {/* --- KẾT THÚC KHỐI MỚI --- */}
        <div className="topic-actions">
          <Link to={`/topics/${topic.id}/learn`} className="btn btn-primary">Learn</Link>
          <div className="review-button-wrapper">
            <Link to={`/topics/${topic.id}/review`} className="btn btn-secondary">
              Review
            </Link>
            {/* Chỉ hiển thị thông báo nếu có từ cần review */}
            {topic.dueReviewCount > 0 && (
              <span className="review-notification-badge">
                {topic.dueReviewCount}
              </span>
            )}
          </div>
          <Link to={`/topics/${topic.id}/listen`} className="btn btn-secondary">Listen</Link>
        </div>
      </div>
    </div>
  );
}

export default TopicCard;